import { Flex } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import AngleRightOutlined from '../../assets/docchat/AngleRightOutlined';
import { getBreadcrumbItems } from './breadcrumbUtils';

const SettingsBreadCrumb = ({ product }) => {
  const location = useLocation();
  const { pathname } = location;
  const breadcrumbItems = getBreadcrumbItems(pathname, product);

  return breadcrumbItems.map((item, index) => (
    <Flex gap={8} className='fs-14 flex align-center' key={item.id}>
      {index < breadcrumbItems.length - 1 ? (
        <span style={{ color: 'var(--grey-7)' }}>
          <Link to={item.to || '#'}>{item.label}</Link>
        </span>
      ) : (
        <span style={{ color: '#15273B', wordBreak: 'break-all' }}>{item.label}</span>
      )}
      {index < breadcrumbItems.length - 1 && <AngleRightOutlined size={18} fill='var(--grey-7)' />}
    </Flex>
  ));
};

export default SettingsBreadCrumb;
